import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap, map } from 'rxjs';
import { environment } from '../../environments/environment';

/** An admin alert (e.g. a partner submitting KYC). `refId` is the related PartnerId. */
export interface AdminNotification {
  id: number;
  type: string; // e.g. "KYC_SUBMITTED"
  title?: string | null;
  message?: string | null;
  refId?: number | null;
  isRead: boolean;
  createdDate?: string | null;
  readDate?: string | null;
}

@Injectable({ providedIn: 'root' })
export class AdminNotificationService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/AdminNotification`;

  /** Shared unread badge count, kept fresh by the bell's poll. */
  readonly unread = signal(0);

  /** GET unread count and push it into the shared signal. */
  loadUnreadCount() {
    return this.http.get(`${this.baseUrl}/GetUnreadCount`).pipe(
      map((res: any) => Number(res?.data?.unread ?? res?.unread ?? 0) || 0),
      tap((n) => this.unread.set(n)),
    );
  }

  getAll(onlyUnread = false, take = 50) {
    return this.http.get(`${this.baseUrl}/GetAll`, { params: { onlyUnread, take } });
  }

  markRead(id: number) {
    return this.http.post(`${this.baseUrl}/MarkRead`, {}, { params: { id } });
  }

  markAllRead() {
    return this.http.post(`${this.baseUrl}/MarkAllRead`, {});
  }

  /** Clear cached count on logout. */
  reset() {
    this.unread.set(0);
  }
}
